module.exports = __webpack_public_path__ + "static/vot-trabajo-f01839586eb1f2178cdf5cd4fd06404b.mp3";